import { defineTrpcContract, mutation, query } from "@amtana/module";

import {
  emptyInputSchema,
  pushSubscriptionSummarySchema,
  subscribeInputSchema,
  unsubscribeInputSchema,
  unsubscribeOutputSchema,
  vapidPublicKeySchema,
} from "./push.schemas.ts";

// Declared once. `notify` is peer-only (notification's own `NoticeService`
// calls it in-process) and carries no tRPC declaration, the same way
// notification's own `notify` does.
export const pushTrpcContract = defineTrpcContract("push", {
  subscribe: mutation({ input: subscribeInputSchema, output: pushSubscriptionSummarySchema }),
  unsubscribe: mutation({ input: unsubscribeInputSchema, output: unsubscribeOutputSchema }),
  vapidPublicKey: query({ input: emptyInputSchema, output: vapidPublicKeySchema }),
});
